// extracted by mini-css-extract-plugin
export default {"crTable":"CryptoRankings_crTable__IaJDG"};